import React from 'react';
interface Props {
  title: string;
}
export const ColHeaderLeft: React.FC<Props> = (props) => {
  return <div className="w-full flex justify-items-start">{props.title}</div>;
};
